// extracted by mini-css-extract-plugin
export default {"photoPost":"UserPhotoPost_photoPost__dyXcg","file":"UserPhotoPost_file__TXl-Z","previews":"UserPhotoPost_previews__Xsxeo"};